import { PuzzleDefinitionSchema, type PuzzleDefinition } from './puzzleDomain';

const originalProvenance = {
  source: 'CapyChess-created practice position',
  author: 'CapyChess',
  original: true,
} as const;

/**
 * A deliberately small, original, offline starter pack. These positions are
 * instructional drills, not copied game data; each line is validated by the
 * schema and fixture tests through chess.js.
 */
export const STARTER_PUZZLES: readonly PuzzleDefinition[] = [
  PuzzleDefinitionSchema.parse({
    id: 'opening-development-multi-ply',
    startFen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
    solutionUci: ['g1f3', 'b8c6', 'f1c4'],
    provenance: originalProvenance,
    license: 'GPL-3.0-or-later',
    teaching: {
      title: 'พัฒนาตัวหมากอย่างมีเป้าหมาย',
      objective: 'พัฒนาม้า ตอบตาของฝ่ายตรงข้าม แล้วพัฒนาบิชอปต่อ',
      themes: ['พัฒนาตัวหมาก', 'หลายตาเดิน', 'ตาเดินเงียบ'],
      hints: ['หาตาเดินพัฒนาตัวหมากที่เป็นธรรมชาติ', 'เริ่มด้วยม้าฝั่งคิง', 'หลังฝ่ายดำพัฒนาตัวหมาก ให้พัฒนาบิชอปจาก f1'],
    },
  }),
  PuzzleDefinitionSchema.parse({
    id: 'capture-checkmate',
    startFen: 'r1bqkb1r/pppp1ppp/2n2n2/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR w KQkq - 4 4',
    solutionUci: ['h5f7'],
    provenance: originalProvenance,
    license: 'GPL-3.0-or-later',
    teaching: {
      title: 'เห็นจังหวะกินตัว',
      objective: 'ใช้ควีนและบิชอปร่วมกันปิดเกม',
      themes: ['กินตัว', 'รุกจน'],
    },
  }),
  PuzzleDefinitionSchema.parse({
    id: 'defensive-development',
    startFen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - 1 2',
    solutionUci: ['b8c6', 'f1b5', 'a7a6'],
    provenance: originalProvenance,
    license: 'GPL-3.0-or-later',
    teaching: {
      title: 'ป้องกันพร้อมพัฒนา',
      objective: 'พัฒนาตัวป้องกัน แล้วค่อยถามบิชอปอย่างใจเย็น',
      themes: ['ป้องกัน', 'พัฒนาตัวหมาก', 'หลายตาเดิน'],
    },
  }),
  PuzzleDefinitionSchema.parse({
    id: 'promotion-practice',
    startFen: 'k7/6P1/8/8/8/8/8/7K w - - 0 1',
    solutionUci: ['g7g8q'],
    provenance: originalProvenance,
    license: 'GPL-3.0-or-later',
    teaching: {
      title: 'เลือกตัวที่เลื่อนขั้น',
      objective: 'ดันเบี้ยและเลือกเลื่อนเป็นควีนด้วยตัวเอง',
      themes: ['เลื่อนขั้น'],
    },
  }),
];
